let _this =  {


	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
		footerButton: $('.franli-footer-button'),
		footerMenu: $('.menu-footer'),
    },

    vars: {
	},

	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {

        function toggleMenu(e) {
          var targetMenu = $($(this).data('target'));

          _this.$dom.footerMenu.each(function() {
            if (!$(this).is(targetMenu)) {
              $(this).removeClass('active');
            }
          });

          _this.$dom.footerButton.each(function() {
            if (!$(this).is(e.currentTarget)) {
              $(this).removeClass('active');
            }
          });

          targetMenu.toggleClass('active');
          $(this).toggleClass('active');
        }

        _this.$dom.footerButton.on('click', toggleMenu);

        $(this).on('click', function(e) {
          if (!$(e.target).is('.franli-footer-menu, .franli-footer-menu *')) {
            _this.$dom.footerMenu.removeClass('active');
            _this.$dom.footerButton.removeClass('active');
          }
        });
    },

};

export default _this;